import { IBankTransferProcessingAccount } from "@wingspanhq/payments/dist/interfaces";
import { queriesPayees } from "@query";
import React, { useMemo } from "react";
import { useXWingspanPayerId } from "../../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { WSQueries } from "../../../../query/WSQuery";
import { selectorPayeeDisplayName } from "../../../../shared/selectors/selectorPayeeDisplayName";
import {
  LayoutSetup,
  LayoutSetupProps
} from "../../../../shared/components/LayoutSetup";
import { WingspanIsPCICertifiedSecure } from "../../../components/ClientPaymentsWrapper/ClientPaymentsWrapper";

type SetupAutopayLayoutProps = Omit<LayoutSetupProps, "title"> & {
  payeeId: string;
  title?(companyName: string): string;
  children(props: {
    payeeName: string;
    domesticBankAccount?: IBankTransferProcessingAccount;
    internationalBankAccount?: IBankTransferProcessingAccount;
  }): React.ReactNode;
};

export const SetupAutopayLayout: React.FC<SetupAutopayLayoutProps> = ({
  payeeId,
  title,
  children,
  ...props
}) => {
  const xWingspanAccount = useXWingspanPayerId();
  const queryPayee = queriesPayees.getPayee.useQuery({
    payeeId,
    xWingspanAccount
  });

  // TODO(v3): gap — payee tag/branding logo has no v3 source (tags at /v3/platform/tags not wired); custom logo dropped.

  const payeeName = useMemo(() => {
    if (!queryPayee.data) {
      return "";
    }
    return selectorPayeeDisplayName(queryPayee.data);
  }, [queryPayee.data]);

  return (
    <>
      <LayoutSetup
        banner={<WingspanIsPCICertifiedSecure name={payeeName} />}
        title={title?.(payeeName)}
        {...props}
      >
        <WSQueries
          queries={{
            queryPayee
          }}
        >
          {() =>
            children({
              payeeName,
              // TODO(v3): gap — payee processing accounts live in the finance domain (external-bank-accounts + payout-settings), not on Payee.
              domesticBankAccount: undefined,
              internationalBankAccount: undefined
            })
          }
        </WSQueries>
      </LayoutSetup>
    </>
  );
};
